import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Helper/Session';

// handle the public routes

function PublicRoute({ component: Component, ...rest }) {
  const token = getToken() !== null ? JSON.parse(getToken()) : '';
  let userPath;
  if (token.admin === '1') {
    userPath = '/user/dashboard';
  }
  if (token.admin === '0') {
    userPath = '/user/dashboard';
  }
  if (token.admin === '0' && token.subscriptionid === "") {
    userPath = '/user/our-mission';
  }
  return (
    <Route
      {...rest}
      render={(props) => !getToken() ? <Component {...props} /> : <Redirect to={{ pathname: userPath }} />}
    />
  )
}

export default PublicRoute;